import React, { useEffect, createElement } from 'react';
export const MetaPixel = () => {
  useEffect(() => {
    // Create and inject the Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
      (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
      fbq('init','1493997328709630');
      fbq('track','PageView');
    `;
    document.head.appendChild(script);
    // Create and inject the noscript pixel image
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1493997328709630&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Add the sales events and UTM pass-through script
    const salesScript = document.createElement('script');
    salesScript.innerHTML = `
      document.addEventListener('DOMContentLoaded', function () {
        fbq('track','ViewContent',{content_category:'sales',content_name:'ardava-sales'});
        document.querySelectorAll('.to-checkout').forEach(function(el){
          el.addEventListener('click', function(){
            fbq('track','InitiateCheckout',{step:'sales'});
          });
        });
        var qs = window.location.search.replace(/^\\?/, '');
        if (qs) {
          document.querySelectorAll('a[data-pass-params="1"]').forEach(function(a){
            var href = a.getAttribute('href') || '';
            a.setAttribute('href', href + (href.indexOf('?')>-1?'&':'?') + qs);
          });
        }
      });
    `;
    document.head.appendChild(salesScript);
    // Create and inject the Microsoft Clarity script
    const clarityScript = document.createElement('script');
    clarityScript.type = 'text/javascript';
    clarityScript.innerHTML = `
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "t7lfiismkb");
    `;
    document.head.appendChild(clarityScript);
    // Cleanup function
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(noscript);
      document.head.removeChild(salesScript);
      document.head.removeChild(clarityScript);
    };
  }, []);
  return null;
};